// src/components/ProtectedRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

function ProtectedRoute({ children, allowedRoles }) {
  const { user } = useUser();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simula tempo di caricamento iniziale per sincronizzarsi con localStorage
    const timer = setTimeout(() => {
      setLoading(false);
    }, 50); // piccolo delay per permettere a useEffect nel context di fare il suo lavoro

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    // Puoi mostrare uno spinner grafico se vuoi
    return null;
  }

  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to="/" />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Loggato ma ruolo non consentito
    return <Navigate to="/" />;
  }

  return children;
}

export default ProtectedRoute;
